import React, { useState } from "react";

const NewsFigure = ({ src, caption, alt }) => {
  const [error, setError] = useState(false);
  return (
    <figure className="my-12" data-testid="news-figure">
      {error ? (
        <div
          className="w-full border border-lime border-dashed flex items-center justify-center"
          style={{ background: "rgba(0,33,71,0.05)", padding: "64px 24px" }}
          data-testid="figure-placeholder"
        >
          <span className="font-condensed uppercase tracking-widest text-lime text-sm">
            Grafico in arrivo
          </span>
        </div>
      ) : (
        <img
          src={src}
          alt={alt || caption}
          loading="lazy"
          className="block w-full h-auto"
          draggable="false"
          onError={() => setError(true)}
        />
      )}
      {caption && (
        <figcaption className="mt-3 text-center text-[14px] text-mandrogni" style={{ fontFamily: "'Hanken Grotesk', sans-serif", fontStyle: "italic" }}>
          {caption}
        </figcaption>
      )}
    </figure>
  );
};

export default NewsFigure;
